import script from "./LayerSwitcherComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LayerSwitcherComponent.vue?vue&type=script&setup=true&lang=js"

import "./LayerSwitcherComponent.vue?vue&type=style&index=0&id=5fa7006c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa7006c"]])

export default __exports__